import type { ReactNode } from "react";

import { Box } from "@mui/material";

import { MOBILE_SUB_HEADER_ZINDEX, mobileSubHeaderTop } from "~/components/mobile/mobileChrome";

interface MobileStickySubHeaderProps {
	children: ReactNode;
	top?: string;
}

const MobileStickySubHeader = ({ children, top = mobileSubHeaderTop }: MobileStickySubHeaderProps) => (
	<Box
		sx={{
			bgcolor: "background.paper",
			position: "sticky",
			top,
			zIndex: MOBILE_SUB_HEADER_ZINDEX
		}}
	>
		{children}
	</Box>
);

export default MobileStickySubHeader;
